import React, { useEffect, useState } from "react";
import Styles from "./Styles.module.css";
import Layout from "Components/Layout";
import { FaUserFriends } from "react-icons/fa";
import { FaHeartbeat } from "react-icons/fa";
import { FaClock } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { FaUsers, FaUserPlus } from "react-icons/fa";
import { getMetrics } from "Services/ServiceRequest";
import Card from "Components/Card/card";
import Loader from "Components/Loader/subload/loader";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

function Page() {
    const [loading, setLoading] = useState(false);
    const [Metrics, setMetrics] = useState([
        {
            title: "Page Views",
            value: 0,
            icon: FaEye,
            color: "#ff9800",
        },
        {
            title: "Total Users",
            value: 0,
            icon: FaUsers,
            color: "#9c27b0",
        },
        {
            title: "New Users",
            value: 0,
            icon: FaUserPlus,
            color: "#9c27b0",
        },
        {
            title: "Sessions",
            value: 0,
            icon: FaUserFriends,
            color: "#4caf50",
        },
        {
            title: "Bounce Rate",
            value: "0%",
            icon: FaHeartbeat,
            color: "#f44336",
        },
        {
            title: "Engaged Sessions",
            value: "0",
            icon: FaClock,
            color: "#2196f3",
        },
    ]);
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        onSubmit(null);
    }, []);
    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const response = await getMetrics(data);
            setLoading(false);
            if (response?.data?.Status === 1) {
                let res = response?.data?.Metrics;
                setMetrics([
                    {
                        title: "Page Views",
                        value: res?.screenPageViews,
                        icon: FaEye,
                        color: "#ff9800",
                    },
                    {
                        title: "Total Users",
                        value: res?.activeUsers,
                        icon: FaUsers,
                        color: "#9c27b0",
                    },
                    {
                        title: "New Users",
                        value: res?.newUsers,
                        icon: FaUserPlus,
                        color: "#9c27b0",
                    },
                    {
                        title: "Sessions",
                        value: res?.sessions,
                        icon: FaUserFriends,
                        color: "#4caf50",
                    },
                    {
                        title: "Bounce Rate",
                        value: `${res?.bounceRate}%`,
                        icon: FaHeartbeat,
                        color: "#f44336",
                    },
                    {
                        title: "Engaged Sessions",
                        value: res?.engagedSessions,
                        icon: FaClock,
                        color: "#2196f3",
                    },
                ]);
            } else {
            }
        } catch (err) {
            setLoading(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };

    return (
        <Layout showBackButton={false} title={""} Active={"google-analytics"}>
            <div className="Main_container">
                <header className={Styles["header"]}>
                    <h3>Google Analytics</h3>
                    <a
                        href="https://analytics.google.com/analytics/web/provision/?utm_source=OGB&utm_medium=app&authuser=1#/provision
"
                        target="_blank">
                        Google Dashboard
                    </a>
                </header>
                {loading && <Loader />}
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className={Styles["form"]}>
                    <div className={Styles["form_control"]}>
                        <label htmlFor="">From Date</label>
                        <input
                            type="date"
                            {...register("fromDate", { required: true })}
                        />
                    </div>
                    <div className={Styles["form_control"]}>
                        <label htmlFor="">To Date</label>
                        <input
                            type="date"
                            {...register("toDate", { required: true })}
                        />
                    </div>
                    <button>Submit</button>
                </form>
                <div className={Styles["wrapper"]}>
                    {Metrics.map((metric, index) => (
                        <Card
                            key={index}
                            title={metric.title}
                            value={metric.value}
                            icon={metric.icon}
                            color={metric.color}
                        />
                    ))}
                </div>
            </div>
        </Layout>
    );
}

export default Page;
